var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{ref:"recaptcha",staticClass:"vue-recaptcha-container",attrs:{"sitekey":"6Lc01QgTAAAAAHBnsjWB7UkhmYRtnwSlJlafkYEk"},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-601d7aa4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./lib/brave-authentication/components/recaptcha.vue
// module id = qU6p
// module chunks = 0